import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  REQUEST, fetchSuccess, fetchFailure,
} from '../../actions/discovery/selectChampion';
import { fetchRequest as fetchTournament } from '../../actions/discovery/tournament';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

// Pick which scored model to deploy (instead of only the auto-selected best).
// The backend materializes the chosen entry through the standard pipeline and
// re-points the tournament champion at it; we refetch the board so its
// "training → Deploy" lifecycle takes over for the new selection.
function* operation(action) {
  try {
    const { goalId, presetId } = action?.payload || {};
    const url = `${config.API_URL}/goals/${goalId}/tournament/champion`;
    const response = yield call(
      axios.post, url, { preset_id: presetId }, { headers: getLocalUser() },
    );
    yield put(fetchSuccess({ presetId, data: response?.data?.data }));
    yield put(fetchTournament({ goalId }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
